import { useMutation, useQuery } from 'react-query'
import axios from 'axios'

const ENDPOINT = `/api/tng-application`
const QUERY_KEY = 'tng-application'

export const usePostApplication = (config = {}) =>
  useMutation((data) => axios.post(`${ENDPOINT}/create-application`, data), config)

export const useGetCount = (config = {}) =>
  useQuery([QUERY_KEY, 'list'], async () => (await axios.get(`${ENDPOINT}/count`)).data, config)
